import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, TextareaAutosize, Theme } from '@material-ui/core';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { FormGroup } from '../../components/FormGroup';
import { TextField } from '../../components/TextField';
import { Button } from '../../components/Button';
import { api } from '../../api';
import { useLoading } from '../../units/loading';
import { useAlert } from '../../units/alert';
import { StatusFalseError } from '../../api/error/StatusFalseError';
import { FrontVodCreateRequestData } from '../../api/frontVodCreate';
import { useFrontCategoryList } from '../../hooks/useFrontCategory';
import { FrontCategorySelectGroup } from '../../components/FrontCategorySelectGroup';
import { usePartner } from '../../hooks/usePartner';

type FeedbackPageProps = {};

FeedbackPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

function useFormData() {
    const [formData, setFormData] = useState<FrontVodCreateRequestData>({
        line_uid: '',
        login: '',
        main_category: '',
        sub_category: '',
        question: '',
    });

    return {
        formData,
        setFormData,
    };
}

function FeedbackPage(props: FeedbackPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const { setIsLoading } = useLoading();
    const alert = useAlert();
    const { formData, setFormData } = useFormData();
    const { frontCategoryList } = useFrontCategoryList();
    const { partner, isLoading: isPartnerLoading, partnerLineUid } = usePartner();

    useEffect(() => {
        setIsLoading(isPartnerLoading);
    }, [isPartnerLoading]);

    function handleSubmitClick() {
        setIsLoading(true);
        api.frontVodCreate({
            ...formData,
            login: partner?.email || '',
            line_uid: partnerLineUid || '',
        })
            .then(() => {
                setIsLoading(false);
                alert.show({
                    type: 'success',
                    title: '操作成功',
                    message: '已成功送出意見反饋',
                    onConfirm: () => history.replace('/feedback'),
                });
            })
            .catch(async (e) => {
                setIsLoading(false);
                if (e instanceof StatusFalseError) {
                    const errorData = await e.response.json();
                    alert.show({
                        type: 'error',
                        title: '錯誤',
                        message: errorData.msg,
                    });
                }
            });
    }

    function canSubmit() {
        const selectedMainFrontCategory = frontCategoryList.find((item) => String(item.id) === formData.main_category);
        return formData.main_category
            && selectedMainFrontCategory
            && (selectedMainFrontCategory.list.length > 0 ? formData.sub_category : true)
            && formData.question;
    }

    return (
        <Page>
            <BackAppBar title="意見反饋" onBackClick={() => history.replace('/feedback')} />
            <PageBody>
                <FormGroup title="問題類別">
                    <FrontCategorySelectGroup
                        frontCategoryList={frontCategoryList}
                        selectedMainId={formData.main_category}
                        selectedSubId={formData.sub_category}
                        onChange={(mainId, subId) => setFormData({
                            ...formData,
                            main_category: mainId,
                            sub_category: subId,
                        })}
                    />
                </FormGroup>
                <FormGroup title="問題內容">
                    <TextField
                        minRows={6}
                        multiline
                        placeholder="請填寫問題內容(限填150字)"
                        value={formData.question}
                        onChange={(e) => setFormData({
                            ...formData,
                            question: e.target.value,
                        })}
                    />
                </FormGroup>
                <FormGroup>
                    <Button onClick={handleSubmitClick} disabled={!canSubmit()}>送出</Button>
                </FormGroup>
            </PageBody>
        </Page>
    );
}

export { FeedbackPage };
